import { useQueryState } from 'core/use-cases/utilities';

import { useComboSelector } from '../selectors';

export function useCombo() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useComboSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}
